module.exports = __webpack_public_path__ + "static/media/card3.a32c772f.png";